import { useParams } from 'react-router-dom';
import { Skeleton, StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { ShieldOff } from 'lucide-react';

import FullPageFrame from '../components/shared/FullPageFrame';
import RoleDetailView from '../components/roles/RoleDetailView';
import { PERMISSIONS } from '../constants/permissions';
import { usePermission } from '../hooks/usePermission';

/**
 * Full-page role detail (`roles/:roleId`). Gated by the roles-view permission; the body lives in
 * `RoleDetailView`.
 *
 * @param {object} props
 * @param {string} props.basePath Where the host mounted People & Access (see `getBasePath`).
 */
function RoleDetailPage({ basePath }) {
  const { t } = useTranslation('people-access');
  const { roleId } = useParams();
  const { allowed, loading } = usePermission(PERMISSIONS.ROLES_VIEW);

  if (loading) {
    return (
      <FullPageFrame>
        <Skeleton height="360px" borderRadius="12px" />
      </FullPageFrame>
    );
  }

  if (!allowed) {
    return (
      <FullPageFrame>
        <StatusMessage
          icon={ShieldOff}
          title={t('roles.detail.state.forbidden.title')}
          subtitle={t('roles.detail.state.forbidden.subtitle')}
        />
      </FullPageFrame>
    );
  }

  return <RoleDetailView key={roleId} roleId={roleId} basePath={basePath} />;
}

export default RoleDetailPage;
